// extracted by mini-css-extract-plugin
module.exports = {"ColorPrimary":"#8e65ff"};